import { render } from "./AdminNav.vue?vue&type=template&id=6168aab6&scoped=true&lang=pug"
import script from "./AdminNav.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminNav.vue?vue&type=script&setup=true&lang=js"

import "./AdminNav.vue?vue&type=style&index=0&id=6168aab6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6168aab6"]])

export default __exports__